export default function initMobileMenu() {
  const button = document.querySelector(".button-hamburger");
  const menu = document.querySelector(".header-menu-mobile-container");
  const closeButton = document.querySelector(".button-close");
  const html = document.querySelector("html");
  button.addEventListener("click", () => {
    menu.classList.add("active");
    html.classList.add("no-scroll");
  });
  closeButton.addEventListener("click", () => {
    menu.classList.remove("active");
    html.classList.remove("no-scroll");
  });
}
